import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ninjaone = defineConnector({
  identifier: "ninjaone",
  name: "NinjaOne",
  tagLine: "IT management and RMM",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://app\\.ninjarmm\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://app.ninjarmm.com/oauth/token",
        formBody: {
          grant_type: "client_credentials",
          client_id: app.secret.clientId,
          client_secret: app.secret.clientSecret,
          scope: "monitoring",
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In NinjaOne, go to **Administration → Apps → API** and create a new client app with the **Client Credentials** grant type. Note the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.ninjarmm.com/api/v2/organizations",
  },
});
